import Scheduling from "./scheduling.component";

export const SchedulingDemo = ({ className, scheduling, onDeselect }) => (
    <div className={ className }>
        <Scheduling scheduling={ scheduling } onDeselect={ onDeselect }/>
    </div>
);

export default SchedulingDemo;